export var AI_SUGGESTION_TRIGGERED_FROM = /*#__PURE__*/function (AI_SUGGESTION_TRIGGERED_FROM) {
  AI_SUGGESTION_TRIGGERED_FROM["ENTER_BUTTON"] = "enterKeydown";
  AI_SUGGESTION_TRIGGERED_FROM["TAB_BUTTON"] = "tabKeydown";
  AI_SUGGESTION_TRIGGERED_FROM["ESCAPE_BUTTON"] = "escapeKeydown";
  AI_SUGGESTION_TRIGGERED_FROM["TOOLBAR"] = "toolbar";
  return AI_SUGGESTION_TRIGGERED_FROM;
}({});